import { useEffect, type ReactNode, useState } from 'react';
import { StoreProvider } from '@/app/providers/StoreProvider';
import { TelegramProvider, useTelegram } from './providers/TelegramProvider';
import { AuthProvider } from './providers/AuthProvider';
import { AppRouter } from './router';
// import { VConsoleProvider } from './providers/VConsoleProvider';
import NotificationWrapper from '@/components/Notifications/NotificationWrapper';
import NavMenu from '@/components/NavMenu/NavMenu';
import { useLocation, useNavigate } from 'react-router-dom';
import StartScreen from '@/components/StartScreen';
import MainPage from '@/pages/Main/MainPage';
import WalletModal from '@/components/WalletModal/WalletModal';
import RaffleModal from '@/components/RaffleModal/RaffleModal';
import {
  getReward,
  loginUser,
  checkWriteAccessOnLoad,
} from '@/api/modules/Login/login';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { onbPass } from '@/api/modules/User/onb';
import useBonusStore from '@/store/BonusStore';
import BonusModal from '@/components/BonusModal/BonusModal';
import RewardModal from '@/components/RewardModal/RewardModal';
import { TadsWidgetProvider } from 'react-tads-widget';
import { TadsCPMHost } from '@/Services/TadsCPMHost';
const queryClient = new QueryClient();

interface AppProps {
  children?: ReactNode;
}

const AppContent: React.FC = () => {
  const [showStartScreen, setShowStartScreen] = useState<boolean | null>(null);
  const [walletOpen, setWalletOpen] = useState(false);
  const [raffleOpen, setRaffleOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { webApp } = useTelegram();
  const setBonus = useBonusStore((state) => state.setBonus);
  const bonusAmount = useBonusStore((state) => state.bonusAmount);
  const setBonusAmount = useBonusStore((state) => state.setBonusAmount);
  const bonus = useBonusStore((state) => state.bonus);
  const [reward, setReward] = useState(false);
  const [rewardData, setRewardData] = useState(null);
  const [currentRewardIndex, setCurrentRewardIndex] = useState(0);
  const [allRewards, setAllRewards] = useState([]);

  useEffect(() => {
    checkWriteAccessOnLoad();
  }, []);

  useEffect(() => {
    async function checkPass() {
      try {
        const data = await loginUser();
        console.log('datasss', data);
        const passed = data.onb_pass;
        const bonus = data.data.data.bonus;
        console.log(bonus);
        setBonus(bonus);
        setBonusAmount(data.data.data.bonus_amount);
        setShowStartScreen(!passed);
      } catch (e) {
        setShowStartScreen(true);
      }
    }
    checkPass();
  }, []);
  useEffect(() => {
    async function fetchReward() {
      const result = await getReward();
      if (result.user_rewards.length > 0) {
        setAllRewards(result.user_rewards);
        setCurrentRewardIndex(0);
        setRewardData(result.user_rewards[0]);
        setReward(true);
      }
    }
    fetchReward();
  }, []);

  const handleOpen = async () => {
    console.log('Нажал на кнопку');
    setShowStartScreen(false);
    await onbPass();
    navigate('/');
  };

  const handleWalletOpen = () => setWalletOpen(true);
  const handleWalletClose = () => setWalletOpen(false);
  const handleRaffleOpen = () => setRaffleOpen(true);
  const handleRaffleClose = () => setRaffleOpen(false);
  const handleBonusClose = () => setBonus(false);
  const handleRewardClose = () => {
    setReward(false);
    // Проверяем, есть ли ещё награды для показа
    const nextIndex = currentRewardIndex + 1;
    if (nextIndex < allRewards.length) {
      // Показываем следующую награду
      setCurrentRewardIndex(nextIndex);
      setRewardData(allRewards[nextIndex]);
      setReward(true);
    } else {
      // Все награды показаны, сбрасываем состояние
      setCurrentRewardIndex(0);
      setAllRewards([]);
      setRewardData(null);
    }
  };
  const walletModal = (
    <WalletModal open={walletOpen} onClose={handleWalletClose} />
  );
  const raffleModal = (
    <RaffleModal open={raffleOpen} onClose={handleRaffleClose} />
  );
  const bonusModal = (
    <BonusModal
      open={bonus}
      onClose={handleBonusClose}
      bonusAmount={bonusAmount}
    />
  );
  const rewardModal = (
    <RewardModal
      open={reward}
      onClose={handleRewardClose}
      rewardData={rewardData}
    />
  );
  useEffect(() => {
    if (location.pathname === '/') {
      document.body.classList.add('main-page');
      document.body.classList.remove('tasks-page');
    } else if (location.pathname === '/tasks') {
      document.body.classList.add('tasks-page');
      document.body.classList.remove('main-page');
    } else {
      document.body.classList.remove('main-page', 'tasks-page');
    }
  }, [location.pathname]);

  if (!webApp || showStartScreen === null) {
    // Можно вернуть Loader, если хотите
    return null;
  }

  // if (showStartScreen) {
  //   return <StartScreen onOpen={handleOpen} />;
  // }

  return (
    <>
      <AppRouter onWalletOpen={handleWalletOpen} />
      <TadsCPMHost />
      {walletModal}
      {raffleModal}
      {bonusModal}
      {rewardModal}
      <NavMenu onRaffleOpen={handleRaffleOpen} />
    </>
  );
};

const App: React.FC = () => {
  return (
    // <VConsoleProvider>
    <TelegramProvider>
      <QueryClientProvider client={queryClient}>
        <TadsWidgetProvider>
          <StoreProvider>
            <AuthProvider>
              <AppContent />
              <NotificationWrapper />
              {/* children prop is removed as it's not defined in the component's props */}
            </AuthProvider>
          </StoreProvider>
        </TadsWidgetProvider>
      </QueryClientProvider>
    </TelegramProvider>

    // </VConsoleProvider>
  );
};

export default App;
